import { Injectable, inject } from '@angular/core';
import { CalAngularService } from '@cvx-dev/cal-angular';
import { firstValueFrom } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CalTokenService {
  private readonly calService = inject(CalAngularService);
  private readonly inFlightRequests = new Map<string, Promise<string>>();

  getAccessToken(scopes: string[]): Promise<string> {
    const normalizedScopes = [...new Set((scopes || []).map((scope) => scope?.trim()).filter(Boolean))];
    if (!normalizedScopes.length) {
      return Promise.resolve('');
    }

    const requestKey = normalizedScopes.slice().sort().join(' ');
    const existingRequest = this.inFlightRequests.get(requestKey);
    if (existingRequest) {
      return existingRequest;
    }

    const tokenRequest = firstValueFrom(this.calService.getAADToken(normalizedScopes, false)).then((response: any) => {
      if (typeof response === 'string') {
        return response;
      }

      return response?.accessToken || '';
    }).finally(() => {
      this.inFlightRequests.delete(requestKey);
    });

    this.inFlightRequests.set(requestKey, tokenRequest);
    return tokenRequest;
  }
}